import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import AppRoutes from './routes';
import GlobalStyle from './styles/GlobalStyle';
import theme from './styles/theme';
import ScrollToTop from './components/common/ScrollToTop';
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { selectAuthUser, selectIsAuthenticated } from './Module/Auth/Presentation/authSelectors';
import { selectUserProfile } from './Module/User/Presentation/userSelectors';
import { getUserDetails } from './Module/User/Presentation/userActions';
import { restoreSession } from './Module/Auth/Presentation/authSlice';
import { resetUserState } from './Module/User/Presentation/userSlice';
import { resetProjectState } from './Module/Project/Presentation/projectSlice';
import { resetSettlementState } from './Module/Settlement/Presentation/settlementSlice';

function App() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const authUser = useAppSelector(selectAuthUser);
  const userProfile = useAppSelector(selectUserProfile);
  const lastUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    // 앱 시작 시 세션 복구 시도
    dispatch(restoreSession());
  }, [dispatch]);

  useEffect(() => {
    const userId = authUser?.user_id || authUser?.id || null;
    const prevUserId = lastUserIdRef.current;
    if (prevUserId !== userId) {
      dispatch(resetUserState());
      dispatch(resetProjectState());
      dispatch(resetSettlementState());
      lastUserIdRef.current = userId;
    }
  }, [dispatch, authUser]);

  useEffect(() => {
    // 사용자가 인증되었고, store의 프로필이 비어있거나 다른 계정이면 사용자 정보를 가져옵니다.
    const userId = authUser?.user_id || authUser?.id;
    const profileUserId = userProfile?.user_id;
    if (isAuthenticated && userId && profileUserId !== userId) {
      dispatch(getUserDetails(userId));
    }
  }, [dispatch, isAuthenticated, authUser, userProfile?.user_id]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <div className="App">
          <ScrollToTop />
          <AppRoutes />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
